import { useReducer } from "react";
import { router } from "./router";
export var Keyword;
(function (Keyword) {
    Keyword["NOT"] = "not";
})(Keyword || (Keyword = {}));
export const defaultInitialState = {
    canSubmit: false,
    defaultFilter: "any",
    filterer: (collection) => collection,
    filters: [],
    focused: false,
    inputText: "",
    isMultiFilter: false,
    keywords: [], // Not keyword should be enabled from configuration
    minLengthSearch: 0,
    placeholderVisible: true,
    reset: false,
    search: "",
    showResults: false,
    tooltipVisible: false,
    whitelist: [],
};
export const reducer = (state, action) => {
    const { type, payload } = action;
    const reduction = router[type];
    return reduction(state, payload);
};
// The actual public API
export const useSearchReducer = (initialState) => {
    const state = Object.assign(Object.assign({}, defaultInitialState), initialState);
    return useReducer(reducer, state);
};
